var _excluded = ["video", "fallbackImg", "isLooped", "isAutoPlayed", "isMuted", "hasControls", "hasControlsOnHover", "poster", "hasBorderRadius", "hasNoMaskImage", "disablePictureInPicture"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useEffect, useState } from "react";
import styled, { css } from "styled-components";
import useBreakpoint from "../../../hooks/useBreakpoint";
import getBorderRadius from "../../../utils/getBorderRadius";
import Picture from "../../quarks/Picture";
export var defaultProps = {
  isMuted: true
};

/**
 * 1. Styles needed to hide tiny border which appear on some devices
 * https://stackoverflow.com/questions/52508598/html5-video-element-on-iphone-has-border
 * */
var VideoAtmStyled = styled.video.withConfig({
  componentId: "sc-1e41m30-0"
})(function (_ref) {
  var $hasPointer = _ref.$hasPointer,
    $hasBorderRadius = _ref.$hasBorderRadius,
    $hasNoMaskImage = _ref.$hasNoMaskImage,
    theme = _ref.theme;
  return css(["max-width:100%;height:auto;cursor:", ";", " ", ""], $hasPointer ? "pointer" : "inherit", !$hasNoMaskImage && css(["mask-image:radial-gradient(#fff,#000);backface-visibility:hidden;"]), $hasBorderRadius && css(["border-radius:", ";"], getBorderRadius(theme, "xlarge")));
});
function VideoAtm(_ref2) {
  var video = _ref2.video,
    fallbackImg = _ref2.fallbackImg,
    isLooped = _ref2.isLooped,
    isAutoPlayed = _ref2.isAutoPlayed,
    _ref2$isMuted = _ref2.isMuted,
    isMuted = _ref2$isMuted === void 0 ? defaultProps.isMuted : _ref2$isMuted,
    hasControls = _ref2.hasControls,
    hasControlsOnHover = _ref2.hasControlsOnHover,
    poster = _ref2.poster,
    hasBorderRadius = _ref2.hasBorderRadius,
    hasNoMaskImage = _ref2.hasNoMaskImage,
    disablePictureInPicture = _ref2.disablePictureInPicture,
    restProps = _objectWithoutProperties(_ref2, _excluded);
  var defaultPixelRatio = 1;
  var _useState = useState(defaultPixelRatio),
    _useState2 = _slicedToArray(_useState, 2),
    pixelRatio = _useState2[0],
    setPixelRatio = _useState2[1];
  var _useState3 = useState(!!hasControls),
    _useState4 = _slicedToArray(_useState3, 2),
    areControlsVisible = _useState4[0],
    setAreControlsVisible = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isPlaying = _useState6[0],
    setIsPlaying = _useState6[1];
  var isSmall = useBreakpoint("small", "medium");
  var isMedium = useBreakpoint("medium", "large");
  useEffect(function () {
    setAreControlsVisible(!!hasControls);
  }, [hasControls]);
  useEffect(function () {
    setPixelRatio(window.devicePixelRatio);
  }, [pixelRatio]);
  var handleOnTouch = function handleOnTouch(event) {
    var videoCurrentTarget = event.currentTarget;
    if (!areControlsVisible) {
      return;
    }
    if (!isPlaying) {
      videoCurrentTarget.play();
    } else if (isPlaying) {
      videoCurrentTarget.pause();
    }
  };
  var sources = function sources(videoSource) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, videoSource.webmSrc ? /*#__PURE__*/React.createElement("source", {
      src: videoSource.webmSrc,
      type: "video/webm"
    }) : null, videoSource.movSrc ? /*#__PURE__*/React.createElement("source", {
      src: videoSource.movSrc,
      type: "video/mp4"
    }) : null, /*#__PURE__*/React.createElement("source", {
      src: videoSource.retinaSrc && pixelRatio >= 2 ? videoSource.retinaSrc : videoSource.src,
      type: "video/mp4"
    }), fallbackImg ? /*#__PURE__*/React.createElement(Picture, {
      srcData: fallbackImg.src,
      alt: fallbackImg.alt
    }) : null);
  };
  var renderVideo = function renderVideo(source, size) {
    return /*#__PURE__*/React.createElement(VideoAtmStyled, _extends({
      key: size,
      height: source.height,
      width: source.width,
      controlsList: "nodownload",
      loop: !!isLooped,
      autoPlay: !!isAutoPlayed,
      onPlaying: function onPlaying() {
        return setIsPlaying(true);
      },
      onPause: function onPause() {
        return setIsPlaying(false);
      },
      onTouchEnd: function onTouchEnd(event) {
        if (hasControlsOnHover) {
          setAreControlsVisible(true);
        }
        handleOnTouch(event);
      },
      onMouseEnter: hasControlsOnHover ? function () {
        return setAreControlsVisible(true);
      } : undefined,
      onMouseLeave: hasControlsOnHover ? function () {
        return setAreControlsVisible(false);
      } : undefined,
      controls: areControlsVisible,
      $hasPointer: areControlsVisible,
      muted: !!isMuted,
      poster: poster,
      playsInline: true,
      $hasBorderRadius: !!hasBorderRadius,
      $hasNoMaskImage: !!hasNoMaskImage,
      disablePictureInPicture: disablePictureInPicture
    }, restProps), sources(source));
  };
  if ("large" in video) {
    var _ref3 = video,
      large = _ref3.large,
      medium = _ref3.medium,
      small = _ref3.small;
    if (isSmall && small) {
      return renderVideo(small, "small");
    }
    if (isMedium && medium) {
      return renderVideo(medium, "medium");
    }
    if (large) {
      return renderVideo(large, "large");
    }
  }
  return renderVideo(video, "default");
}
export default VideoAtm;